import { Controller } from "react-hook-form";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../ui";
import { FormLabel } from "../FormLabel";
import { FormErrorLabel } from "../FormErrorLabel";
import { BadgeInfo } from "lucide-react";
import { RichTextEditor } from "@/components";

const FormRichTextEditor = ({
  name,
  label,
  control,
  error,
  isRequired,
  onChange,
  noSpace,
  info,
  ...rest
}: any) => {
  return (
    <div className="relative flex flex-col items-start gap-1">
      {label && (
        <FormLabel>
          {label}{" "}
          {rest?.disabled ? (
            <> </>
          ) : (
            <span className="text-red-700">{isRequired ? "*" : ""}</span>
          )}
          {info && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger className="mx-1" type="button">
                  <BadgeInfo className="h-3 w-3 stroke-yellow-600" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>{info}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <RichTextEditor value={field.value} onChange={(val: any) => field.onChange(val)} disabled={rest.disabled} />
        )}
      />
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};

export default FormRichTextEditor;
